module.exports = __webpack_public_path__ + "static/media/step-7-seal.013724db.svg";